export var UploadContentType;
(function (UploadContentType) {
    UploadContentType["CSV"] = "text/csv";
    UploadContentType["PDF"] = "application/pdf";
    UploadContentType["DOCX"] = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    UploadContentType["DOC"] = "application/msword";
    UploadContentType["PPTX"] = "application/vnd.openxmlformats-officedocument.presentationml.presentation";
    UploadContentType["XLSX"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    UploadContentType["MARKDOWN"] = "text/markdown";
    UploadContentType["PLAIN_TEXT"] = "text/plain";
    UploadContentType["HTML"] = "text/html";
    UploadContentType["JSON"] = "application/json";
})(UploadContentType || (UploadContentType = {}));
//# sourceMappingURL=uploadContentType.enum.js.map